import { render, staticRenderFns } from "./SpeciesCustomization.vue?vue&type=template&id=0955100e&scoped=true"
import script from "./SpeciesCustomization.vue?vue&type=script&lang=ts"
export * from "./SpeciesCustomization.vue?vue&type=script&lang=ts"
import style0 from "./SpeciesCustomization.vue?vue&type=style&index=0&id=0955100e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0955100e",
  null
  
)

export default component.exports